import { createContext, type Context, type Dispatch, type SetStateAction } from 'react';

import noop from 'lodash/noop';

export const WillRedirectOnLoadContext: Context<boolean> = createContext(false);
export const SetWillRedirectOnLoadContext: Context<Dispatch<SetStateAction<boolean>>> =
	createContext<Dispatch<SetStateAction<boolean>>>(noop);
